import AddIcon from "@mui/icons-material/Add"
import { Box, Button, Grid, Typography } from "@mui/material"
import { Form, Formik, FormikProps } from "formik"
import { isNil } from "lodash"
import { useRef } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { CircleLoader } from "react-spinners"
import AuthorizeScreen from "../../../core/auth/Authorize"
import { BaseUrlParam } from "../../../core/components/BaseUrlParam"
import BaseTextField from "../../../core/components/base/BaseTextField"
import { LocationQueryAutocomplete } from "../../hints/LocationAutocomplete"
import { OotTrickLinkDto } from "../OotTricksDtos"
import { CreateOotTrickDto, useMutateCreateOotTrick, useMutateUpdateOotTrick, useQueryOotTrickById } from "../OotTricksQuery"
import CreateTrickLink from "./CreateTrickLink"
const CreateTrickScreen = () => {

    let ref = useRef<FormikProps<CreateOotTrickDto>>(null);
    let createTrick = useMutateCreateOotTrick(ref);
    let updateTrick = useMutateUpdateOotTrick(ref);
    let navigate = useNavigate();

    let { id } = useParams<BaseUrlParam>()

    let { data: trick, isLoading, isFetching } = useQueryOotTrickById(Number(id));


    if (isLoading || isFetching)
        return <Box display="flex" justifyContent={"center"} flexDirection={"column"}>
            <Typography component="h2">Loading the element</Typography>
            <CircleLoader />
        </Box>

    let initialValue = trick;
    if (isNil(trick) || window.location.href.includes("create"))
        initialValue = {
            id: 0,
            description: "",
            links: [],
            name: "",
            nbLinks: 0,
            location: null
        }

    const onSubmit = async (values: CreateOotTrickDto) => {

        if (window.location.href.includes("create"))
            await createTrick.mutateAsync(values).then(() => navigate("/ootr/tricks"));
        else
            await updateTrick.mutateAsync(values).then(() => navigate("/ootr/tricks"))
        
        navigate("/ootr/tricks")
    }




    return <AuthorizeScreen roles={["Admin"]}>
        <Formik<CreateOotTrickDto>
            onSubmit={async (values) => await onSubmit(values)}
            initialValues={initialValue}
            innerRef={ref}
        >
            {({ values, setFieldValue }) => {

                const updateTrick = (value: OotTrickLinkDto, index: number) => {

                    console.log(index, value);

                    if (index === 0)
                        setFieldValue("links", [value, ...values.links.slice(1)])
                    else if (index === values.links.length - 1)
                        setFieldValue("links", [...values.links.slice(0, values.nbLinks - 2), value])
                    else
                        setFieldValue("links", [
                            ...values.links.slice(0, index - 1),
                            value,
                            ...values.links.slice(index + 1, values.nbLinks - 1)])
                }
                return <Form>
                    <Grid container spacing={2}>
                        <Grid item xs={12} textAlign={"center"}>
                            <h2>Create New Trick</h2>
                        </Grid>
                        <Grid item xs={3} />
                        <Grid item xs={3} container justifyContent={"center"}>
                            <BaseTextField label="Name" value={values.name} onChange={(v) => setFieldValue("name", v.currentTarget.value)} />
                        </Grid>

                        <Grid item xs={3} container justifyContent={"center"}>
                            <BaseTextField label="Description" value={values.description} onChange={(v) => setFieldValue("description", v.currentTarget.value)} />
                        </Grid>
                        <Grid item xs={3} />

                        <Grid item xs={3} />
                        <Grid item xs={6}>
                            <LocationQueryAutocomplete
                                selection={values.location}
                                label="Location"
                                additionalOnChange={(v) => setFieldValue("location", v)}
                            />
                        </Grid>
                        <Grid item xs={3} />

                        <Grid item xs={3} />
                        <Grid item xs={6} container>

                            {Array.from(Array(values.nbLinks).keys()).map((e, i) => {
                                return <CreateTrickLink values={values} index={i} updateTrick={updateTrick} />
                            })}
                            <Button startIcon={<AddIcon />} onClick={() => {
                                setFieldValue("links", [...values.links, { difficulty: null, url: "", name: "" } as OotTrickLinkDto])
                                setFieldValue("nbLinks", values.nbLinks + 1)
                            }}>Add Link</Button>
                        </Grid>
                        <Grid item xs={3} />



                        <Grid item xs={3} />
                        <Grid item xs={6} justifyContent={"center"} container>
                            <Button type="button" sx={{ color: "red", border: "1px solid red" }} onClick={() => navigate("/ootr/tricks")}>Back</Button>
                            <Button type="submit" sx={{ color: "green", border: "1px solid green" }}>Create</Button>
                        </Grid>
                        <Grid item xs={3} />

                    </Grid>
                </Form>
            }}
        </Formik>
    </AuthorizeScreen>
}

export default CreateTrickScreen